import constants from '../helpers/constants.js';
import initialState from './initialState.js';
import _ from 'lodash';





export default function accountReducer (state = initialState.AccountDetails, action) {
  switch (action.type) {
    case constants.ACCOUNT_USER_SETTINGS:
      return  Object.assign({}, state, {customerDetails: action.data});
    case constants.ACCOUNT_CUSTOMER_DETAILS_SUCCESS:
    	action.data['customerDetails'] = state.customerDetails;
      return Object.assign({}, state, action.data);
    case constants.ACCOUNT_DETAILS_ISINIT_UPDATE:
      return Object.assign({}, state, {isInit:action.data});
    case constants.ACCOUNT_DETAILS_ISCUSTOMERLOADED_UPDATE:
      return Object.assign({}, state, {isCustomerLoaded:action.data}); 
    case constants.ACCOUNT_USER_DETAILS_UPDATE:
      return Object.assign({}, state, {user:action.data});
    default:
      return state;
  }
}